(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("@angular/common"));
	else if(typeof define === 'function' && define.amd)
		define("ngx-icon-picker", ["@angular/core", "@angular/common"], factory);
	else if(typeof exports === 'object')
		exports["ngx-icon-picker"] = factory(require("@angular/core"), require("@angular/common"));
	else
		root["ngx-icon-picker"] = factory(root["@angular/core"], root["@angular/common"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_12__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition